import request from "@/utils/request";

let domain = '';
if(window.location.host.includes('-p')){
	domain = 'https://p.landui.com/';
}else if(window.location.host.includes('.st')){
	domain = 'https://www.st.landui.cn/';
}else if(window.location.host.includes('dev') || window.location.host.includes('localhost')){
	domain = 'http://www.zj.dev.landui.cn/';
}else{
	domain = 'https://www.landui.com/';
}

export function lduploadfile(param) {
  return request({
	url: domain + 'api/upload/uploadfile',
    method: 'post',
	headers: { "Content-Type": "multipart/form-data" }, 
	data: param
  })
}

export function captchaFetch() {
  return request({
    url: 'api/common/captcha',
    method: 'get'
  })
}

export function sendemailcode(param) {
  return request({
    url: 'api/users/secver/sendemailcode',
    method: 'post',
	data: param
  })
}

export function sendsmscode(param) {
  return request({
    url: 'api/users/secver/sendsmscode',
    method: 'post',
	data: param
  })
}

export function checksecvarcode(param) {
  return request({
    url: 'api/users/secver/checksecvarcode',
    method: 'post',
	data: param
  })
}

export function sendsmscodeBind(param) {
  return request({
    url: 'api/users/secure/sendsmscodebindingmobile',
    method: 'post',
	data: param
  })
}

export function sendemailcodeBind(param) {
  return request({
    url: 'api/users/secure/sendemailcodebindingemail',
    method: 'post',
	data: param
  })
}

export function getareainfo(param) {
  return request({
    url: 'api/common/getareainfo?id='+param,
    method: 'get'
  })
}

